import { getUser } from 'app/auth/selectors';
import { connect } from 'react-redux';
import type { RouterSlice } from '../../../app-state.js';
import type { AuthSlice } from '../../../auth/types.js';
import type { UserMenuProps } from './types.js';
import UserMenu from './user-menu.js';

export const mapStateToProps = (state: AuthSlice & RouterSlice): UserMenuProps => {
  return {
    pathname: state.router.pathname,
    user: getUser(state).data
  };
};

export default connect(mapStateToProps)(UserMenu);
